import { AnyAction } from 'redux';
import ActionTypes from '../../../../../constants/ActionTypes';
import { IStoreState } from './types';

const initialState: IStoreState = {
  visibility: false,
  stb: {
    numberOfDevices: 0,
    selectedNumberOfDevices: 1
  }
};

const additionalDevicesReducer = (
  state = initialState,
  action: AnyAction
): IStoreState => {
  switch (action.type) {
  case ActionTypes.MANHATTAN.FTTH.ADDITIONAL_DEVICES.SET_VISIBILITY:
    return {
      ...state,
      visibility: action.payload
    };
  case ActionTypes.MANHATTAN.FTTH.ADDITIONAL_DEVICES.SET_STB_NUMBER:
  case ActionTypes.MANHATTAN.FTTH.ADDITIONAL_DEVICES.SET_SELECTED_STB_NUMBER:
    return {
      ...state,
      stb: action.payload
    };
  }

  return state;
};

export default additionalDevicesReducer;
